import { ChevronDown, ChevronRight } from "lucide-react";

const navItems = [
  { label: "Split Systems", hasDropdown: false, href: "/ac-types/split-system" },
  { label: "Ducted Systems", hasDropdown: false, href: "/ac-types/ducted-system" },
  { label: "Air Con Types", hasDropdown: false, href: "/ac-types" },
  { label: "Brands", hasDropdown: false, href: "/brands" },
  { label: "Our Services", hasDropdown: false, href: "/services" },
  { label: "Specials", hasDropdown: false, href: "/specials" },
  { label: "About Us", hasDropdown: false, href: "/about" },
  
  { label: "Upload Plans", hasDropdown: false },
];

const MainNav = () => {
  return (
    <nav className="bg-acg-charcoal">
      <div className="container mx-auto flex items-center justify-between px-4">
        <ul className="flex items-center">
          {navItems.map((item) => (
            <li key={item.label}>
              <a
                href={item.href || "#"}
                className="flex items-center gap-1 px-4 py-4 text-sm font-semibold text-primary-foreground hover:bg-primary transition-colors uppercase tracking-wide"
              >
                {item.label}
                {item.hasDropdown && <ChevronDown className="w-3 h-3" />}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="#commercial"
          className="hidden lg:flex items-center gap-1 text-sm font-semibold text-primary-foreground hover:text-primary transition-colors"
        >
          See Our Commercial Division
          <ChevronRight className="w-4 h-4" />
        </a>
      </div>
    </nav>
  );
};

export default MainNav;
